import React, { FC } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import DeleteIcon from "@mui/icons-material/Delete";
import "./SCUIOperatorMainRow.scss";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import { OperatorCommand } from "../../../services/command";
import { useTranslation } from "react-i18next";

interface IProps {
  row: any;
  refreshOperatorList?: any;
  roleId?: any;
}
export const SCUIOperatorMainRow: FC<IProps> = ({
  row,
  refreshOperatorList,
  roleId,
}) => {
  const { t } = useTranslation();
  function deleteOperator(row: any) {
    Swal.fire({
      text: t("general.sureText") + " " + row.username,
      cancelButtonText: t("general.cancel"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("general.removeUser"),
    }).then((result: any) => {
      if (result.isConfirmed) {
        let params: any = {};
        params.applicationUserId = Number(row.applicationUserId);
        params.roleId = Number(roleId);

        OperatorCommand.DeleteOperatorFromRole(params)
          .then((res: any) => {
            Swal.fire(res.message, t("general.deleted"), "success");
            refreshOperatorList();
          })
          .catch((error: any) => {
            Swal.fire("", t("general.couldntDeleted"), "error");
            console.log("Hata :>> ", error);
          })
          .finally(() => {});
      }
    });
  }

  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        key={row.operatorItemId}
      >
        <TableCell align="center">{row.username}</TableCell>
        <TableCell align="center">{row.operatorId}</TableCell>
        <TableCell align="center">{row.domainName}</TableCell>
        <TableCell align="center">
          <Button onClick={() => deleteOperator(row)}>
            <DeleteIcon />
          </Button>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
